import {
  Assessment,
  Assignment,
  People,
  ConfirmationNumber,
  BarChart,
  Settings,
  Visibility,
  Policy,
  AssignmentReturned,
  MonetizationOn,
  LibraryBooks,
  HomeWork,
  Security,
  LocalFireDepartment,
  Person,
  Business,
  PlaylistAddCheck,
  CreditCard,
  ReceiptLong,
  SwapHoriz,
  Schedule,
  Email,
  AdminPanelSettings,
  Construction,
  Dashboard,
  AccountBalance,
  Handshake,
  Spa,
  AccountBalanceWallet,
  Timeline,
  ReportProblem,
  Update,
  ListAlt,
  NotificationsActive,
  CheckCircleOutline,
  Payments,
  PointOfSale,
  ExitToApp,
  Gavel,
  Search,
  History,
  Label,
  CurrencyExchange,
  LocalAtm,
  Savings,
  RequestQuote,
  FactCheck,
  Tune,
  Campaign,
  Cake,
} from '@mui/icons-material';
import packageJson from '../../../../package.json';

export const APP_VERSION_DISPLAY = (() => {
  const rawVersion = packageJson.version || '1.0.0';
  const segments = String(rawVersion).split('.');
  const [major = '1', minor = '0'] = segments;
  return `${major}.${minor}`;
})();

export const LAYOUT_CONFIG = {
  desktop: {
    headerHeight: 56,
    sidebarWidth: 280,
  },
  mobile: {
    headerHeight: 56,
    contentMarginTop: 0,
  },
};

export const MENU_ITEMS = [
  {
    label: 'Planes',
    icon: <Assessment />,
    children: [
      {
        label: 'Plan Habitat 99',
        path: '/plan/ver-planes',
        icon: <Assignment />,
        requiredModule: 'Planes',
      },
      {
        label: 'Plan Aniversario',
        path: '/cupon/plan-aniversario',
        icon: <Cake />,
        requiredModule: 'Habitat 99',
      },
    ],
  },
  {
    label: 'Contrato',
    icon: <Assignment />,
    children: [
      {
        label: 'Ver Contratos',
        path: '/contratos',
        icon: <AssignmentReturned />,
        requiredModule: 'Contratos',
      },
      {
        label: 'Impuesto inmobiliario',
        path: '/contrato/real-state-tax',
        icon: <HomeWork />,
        requiredModule: 'Impuesto Inmobiliario',
      },
      {
        label: 'Seguro de Vida',
        path: '/contrato/seguro-vida',
        icon: <Security />,
        requiredModule: 'Seguro de Vida',
      },
      {
        label: 'Seguro de incendio',
        path: '/contrato/seguro-incendio',
        icon: <LocalFireDepartment />,
        requiredModule: 'Seguro de Incendio',
      },
    ],
  },
  {
    label: 'Entidades',
    icon: <People />,
    children: [
      {
        label: 'Suscriptores',
        path: '/entidades/suscriptores',
        icon: <Person />,
        requiredModule: 'Suscriptores',
      },
      {
        label: 'Personas juridicas',
        icon: <Business />,
        path: '/entidades/personas-juridicas',
        requiredModule: 'Personas Jurídicas',
      },
    ],
  },
  {
    label: 'Habitat 99',
    icon: <ConfirmationNumber />,
    children: [
      {
        label: 'Cupones',
        icon: <ReceiptLong />,
        children: [
          {
            label: 'Generar cupones',
            path: '/cupon/generar/generar-cupones',
            icon: <PlaylistAddCheck />,
            requiredModule: 'Generar Cupones',
          },
          {
            label: 'Control de generación',
            path: '/cupon/generar/control-generacion',
            icon: <Schedule />,
            requiredModule: 'Control de Generación',
          },
          {
            label: 'Ver cupones',
            path: '/cupon/cupones/',
            icon: <LibraryBooks />,
            requiredModule: 'Ver Cupones',
          },
          {
            label: 'Planes regularizados',
            path: '/cupon/cupones/planes-regulariza',
            icon: <CheckCircleOutline />,
            requiredModule: 'Planes Regularizados',
          },
        ],
      },
      {
        label: 'Registrar',
        icon: <PointOfSale />,
        children: [
          {
            label: 'Registar cobro',
            path: '/cupon/registrar/registrar-cobro',
            icon: <CreditCard />,
            requiredModule: 'Registrar Cobro',
          },
          {
            label: 'Cobros externos',
            path: '/cupon/registrar/cobros-externos',
            icon: <Payments />,
            requiredModule: 'Cobros Externos',
          },
          {
            label: 'Ver cobros',
            path: '/cupon/registrar/ver-cobros',
            icon: <MonetizationOn />,
            requiredModule: 'Ver Cobros',
          },
        ],
      },

      {
        label: 'Mora',
        icon: <ReportProblem />,
        children: [
          {
            label: 'Actualizar deuda',
            path: '/cupon/cupones/actualizar-deuda',
            icon: <Update />,
            requiredModule: 'Actualizar Deuda',
          },
          {
            label: 'Detalle mora',
            path: '/cupon/cupones/detalle-mora',
            icon: <ListAlt />,
            requiredModule: 'Detalle Mora',
          },
          {
            label: 'Estado de mora',
            path: '/cupon/cupones/estado-mora',
            icon: <Tune />,
            requiredModule: 'Detalle Mora',
          },
          {
            label: 'Notificaciones de cupones por vencer',
            path: '/cupon/cupones/notificaciones-mora',
            icon: <NotificationsActive />,
            requiredModule: 'Notificaciones de Cupones por Vencer',
          },
        ],
      },
      {
        label: 'Diferimiento',
        icon: <Savings />,
        children: [
          {
            label: 'Intenciones de pago',
            path: '/cupon/diferimientos/resumen',
            icon: <RequestQuote />,
            requiredModule: 'Diferimiento',
          },
          {
            label: 'Facturas',
            path: '/cupon/diferimientos/facturas',
            icon: <FactCheck />,
            requiredModule: 'Diferimiento',
          },
        ],
      },
      {
        label: 'Cupones por mail',
        path: '/cupon/impresion/cupones-mail',
        icon: <Email />,
        requiredModule: 'Cupones por Mail',
      },
      {
        label: 'Notificaciones mobile',
        icon: <Campaign />,
        children: [
          {
            label: 'Historial mobile',
            icon: <ListAlt />,
            requiredModule: 'Habitat 99',
            path: '/cupon/notificaciones/mobile',
          },
          {
            label: 'Notificaciones Push',
            icon: <NotificationsActive />,
            requiredModule: 'Habitat 99',
            path: '/cupon/notificaciones/push',
          },
        ],
      },
      {
        label: 'ARCA',
        icon: <Gavel />,
        children: [
          {
            label: 'Consultar factura',
            path: '/cupon/registrar/ver-factura-afip',
            icon: <Search />,
            requiredModule: 'Ver Factura AFIP',
          },
          {
            label: 'Última factura',
            path: '/cupon/registrar/ultima-factura-afip',
            icon: <History />,
            requiredModule: 'Ver Factura AFIP',
          },
        ],
      },
    ],
  },
  {
    label: 'Puntaje',
    path: '/cupon/puntaje',
    icon: <FactCheck />,
    requiredAnyModules: ['Puntaje'],
  },
  {
    label: 'Obra',
    icon: <Construction />,
    children: [
      {
        label: 'Seguimiento',
        icon: <Visibility />,
        children: [
          {
            label: 'Proyectos',
            path: '/obra/seguimiento/proyectos',
            icon: <Dashboard />,
            requiredModule: 'Proyectos',
          },
          {
            label: 'Plantillas',
            path: '/obra/seguimiento/plantillas',
            icon: <PlaylistAddCheck />,
            requiredModule: 'Plantillas',
          },
          {
            label: 'Dashboard',
            path: '/obra/seguimiento/dashboard-avance',
            icon: <BarChart />,
            requiredModule: 'Dashboard Obra',
          },
          {
            label: 'Avance Histórico',
            path: '/obra/seguimiento/avance-historico',
            icon: <Timeline />,
            requiredModule: 'Dashboard Obra',
          },
          {
            label: 'Comentarios Calidad',
            path: '/obra/seguimiento/comentarios-calidad',
            icon: <FactCheck />,
            requiredModule: 'Dashboard Obra',
          },
          {
            label: 'Subcontratistas',
            path: '/obra/seguimiento/subcontratistas',
            icon: <Handshake />,
            requiredModule: 'Subcontratistas',
          },
          {
            label: 'Tipos de construcción',
            path: '/obra/seguimiento/tipos-construccion',
            icon: <Tune />,
            requiredModule: 'Proyectos',
          },
        ],
      },
      {
        label: 'Lotes',
        icon: <HomeWork />,
        children: [
          {
            label: 'Loteos',
            path: '/obra/lotes/loteos',
            icon: <Label />,
            requiredModule: 'Lotes',
          },
          {
            label: 'Lotes',
            path: '/obra/lotes/lotes',
            icon: <ConfirmationNumber />,
            requiredModule: 'Lotes',
          },
          {
            label: 'Boletos',
            path: '/obra/lotes/boletos',
            icon: <Assignment />,
            requiredModule: 'Lotes',
          },
        ],
      },
    ],
  },
  {
    label: 'Bancos',
    icon: <AccountBalance />,
    children: [
      {
        label: 'Movimientos',
        path: '/bancos/movimientos',
        icon: <Spa />,
        requiredModule: 'Movimientos',
      },
      {
        label: 'Informe proyectado',
        path: '/bancos/informe-proyectado',
        icon: <Timeline />,
        requiredModule: 'Movimientos',
      },
      {
        label: 'Órdenes de pago',
        path: '/bancos/ordenes-de-pago',
        icon: <Payments />,
        requiredModule: 'Ordenes de Pago',
      },
      {
        label: 'Cheques de canje',
        path: '/bancos/cheques-canje',
        icon: <CurrencyExchange />,
        requiredModule: 'Cheques de Canje',
      },
      {
        label: 'Retenciones y efectivo',
        path: '/bancos/retenciones-efectivo',
        icon: <LocalAtm />,
        requiredModule: 'Retenciones y Efectivo',
      },
      {
        label: 'Configuración',
        icon: <Tune />,
        children: [
          {
            label: 'Cuentas Bancarias',
            path: '/bancos/cuentas',
            icon: <AccountBalanceWallet />,
            requiredModule: 'Cuentas Bancarias',
          },
          {
            label: 'Tipos de movimiento',
            path: '/bancos/tipos-de-movimiento',
            icon: <SwapHoriz />,
            requiredModule: 'Tipos de Movimiento',
          },
          {
            label: 'Conceptos de movimiento',
            path: '/bancos/conceptos-de-movimiento',
            icon: <Label />,
            requiredModule: 'Conceptos de Movimiento',
          },
          {
            label: 'Beneficiarios',
            path: '/bancos/subcontratistas',
            icon: <Handshake />,
            requiredModule: 'Subcontratistas',
          },
        ],
      },
    ],
  },
  {
    label: 'Estadisticas',
    icon: <BarChart />,
    children: [
      {
        label: 'Habitat 99',
        path: '/cupon/estadisticas-habitat99',
        icon: <BarChart />,
        requiredModule: 'Estadísticas Habitat 99',
      },
      {
        label: 'Entidades recaudadoras',
        path: '/cupon/estadisticas-entidades-recaudadoras',
        icon: <BarChart />,
        requiredModule: 'Estadísticas Entidades Recaudadoras',
      },
      {
        label: 'Gerenciales',
        path: '/cupon/estadisticas-gerenciales',
        icon: <BarChart />,
        requiredModule: 'Estadísticas Gerenciales',
      },
    ],
  },
  {
    label: 'Administracion',
    icon: <Settings />,
    children: [
      {
        label: 'Auditoría',
        icon: <Policy />,
        requiredModule: 'Modulo auditoria',
        path: '/administracion/auditoria',
      },
      {
        label: 'Usuarios',
        path: '/administracion/usuarios',
        icon: <Person />,
        requiredModule: 'Usuarios',
      },
      {
        label: 'Perfiles',
        path: '/administracion/perfiles',
        icon: <AdminPanelSettings />,
        requiredModule: 'Perfiles',
      },
      {
        label: 'Sucursales',
        path: '/administracion/sucursales',
        icon: <Business />,
        requiredModule: 'Sucursales',
      },
      {
        label: 'Notificaciones',
        path: '/administracion/notificaciones',
        icon: <NotificationsActive />,
        requiredModule: 'Configuración de Notificaciones',
      },
    ],
  },
  {
    label: 'Cerrar sesión',
    icon: <ExitToApp />,
    isLogout: true,
  },
  {
    label: `v${APP_VERSION_DISPLAY}`,
    isVersionTag: true,
  },
];
